import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const LW = sizes.w650;

export default function AuthorizedDeviation() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
        quotaDeviationPercentage,
        modificationDeviationPercentage
	} = setupState;

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	return (
		<Box sx={{ mt: 4, p: 2, border: 1, borderRadius: 1, borderColor: "#c6c6c6"}}>
			<Box sx={{ mt: 0 }}>
				<Typography sx={{ color: "black.main", fontWeight: "600", fontSize:"14px" }}>
                    Authorised Deviation %
				</Typography>
			</Box>
			<Box sx={{ mt: 4 }}>
				<Grid container columns={12} columnSpacing={2} alignContent={"space-between"} >
                    <Grid item sm={6} md={6}>
						<Box>
							<TextField
								type={"number"}
								id="outlined-basic"
								label="Define Quota vs Revised/Approved Quota"
								variant="outlined"
								size="small"
								sx={{
									width:"100%"
								}}
								value={quotaDeviationPercentage}
								onChange={(event) =>{
									const inputValue = parseFloat(event.target.value);
    								if (isNaN(inputValue) || inputValue >= 0) {
										handleStateUpdate(event, "quotaDeviationPercentage");
									}
								}}
							/>
						</Box>
					</Grid>

					<Grid item sm={6} md={6}>
						<Box>
							<TextField
								type={"number"}
								id="outlined-basic"
								label="Modified Quota vs Original Quota"
								variant="outlined"
								size="small"
								sx={{
									width:"100%"
								}}
								value={modificationDeviationPercentage}
								onChange={(event) =>{
									const inputValue = parseFloat(event.target.value);
    								if (isNaN(inputValue) || inputValue >= 0) {
										handleStateUpdate(event, "modificationDeviationPercentage")
									}
								}}
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}
